import { SxProps } from '@mui/material';

export const catalogEntryListCompareCollectorActionsButtonClearSX: SxProps = {
	border: 'none',
	color: 'secondary.main',
	fontSize: '14px',
	fontWeight: '500',
	padding: '0 5px',
	'&:hover': {
		color: 'secondary.main',
		textDecoration: 'underline',
		border: 'none',
		backgroundColor: 'transparent',
	},
};
